import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    "input",
    "medal"
  ]

  static values = {
    "selected": Number
  }

  connect () {
    let pre_select = document.querySelector(`.medals .profile-medal[data-medal='${this.selectedValue}']`)

    if (pre_select) {
      pre_select.classList.add('selected')
    }
  }

  pick(event) {
    if (event.currentTarget.dataset.medal == this.selectedValue) {
      event.currentTarget.classList.remove('border-blue-500')
      this.inputTarget.value = "0"
    } else {
      let divs = this.medalTargets
      for (var i = 0; i < divs.length; i++) {
        divs[i].classList.remove('selected')
      }

      event.currentTarget.classList.add('selected')
      this.selectedValue = event.currentTarget.dataset.medal

      this.inputTarget.value = event.currentTarget.dataset.medal
    }
  }
}
